module.exports = __webpack_public_path__ + "static/pasta-2-64b6c51300200ee5ff44569035574b59.jpg";